import { useLocation } from "react-router-dom";
import { BUYER_FRAME_STEPS, stepIndex } from "../../js/utils/formatters";
import { GatedNavLink } from "./GatedLink";
import { toTitleCase } from "../../js/utils/titleCase";

export default function BuyerNav() {
  const { pathname } = useLocation();
  const current = stepIndex(pathname);

  const step = BUYER_FRAME_STEPS[current] || BUYER_FRAME_STEPS[0];
  const place = current >= 0 ? current + 1 : 1;

  return (
    <nav className="buyer-nav" aria-label="Checklist steps" data-tour="buyer-subnav">
      <p className="journey-step-meta">
        Buyer · {place} of {BUYER_FRAME_STEPS.length} · {toTitleCase(step?.label || "Start")}
      </p>
      <ol className="buyer-nav-list">
        {BUYER_FRAME_STEPS.map((step, index) => (
          <li key={step.path} data-tour={`buyer-mark-${index}`}>
            <GatedNavLink
              to={step.path}
              allow
              className={({ isActive }) =>
                `buyer-step${isActive ? " is-active" : ""}${index < current ? " is-done" : ""}`
              }
            >
              {toTitleCase(step.label)}
            </GatedNavLink>
          </li>
        ))}
      </ol>
    </nav>
  );
}
